export default {
  FIR: "Mise à jour du micrologiciel des lunettes AR RayNeo",
  NO: "La mise à jour du micrologiciel n’est pas encore prise en charge sur les appareils mobiles",
  TIPS: "Pour mettre à jour le micrologiciel, utilisez l’un des navigateurs suivants sur votre ordinateur",
  pageTitle: "Mise à jour du micrologiciel des lunettes AR RayNeo",
  connectStep: "Connecter",
  updateStep: "Mettre à jour",
  supportedModels:
    "Modèles pris en charge : RayNeo GT, RayNeo GT MAX, RayNeo Air 4 Pro, RayNeo Air 4, RayNeo Air 3s Pro, RayNeo Air 3s, RayNeo Air 3, RayNeo Air 2s, RayNeo Air 2, RayNeo Air Plus et RayNeo Air 1s.",
  desktopBrowserRequirement:
    "Utilisez la version pour ordinateur de Chrome ou d’Opera (version 89 ou ultérieure).",
  singleDeviceRequirement:
    "Veillez à ne connecter qu’une seule paire de lunettes RayNeo à votre ordinateur pendant la mise à jour.",
  displayFlickerNotice:
    "L’écran peut scintiller brièvement après la connexion des lunettes. Ceci est normal.",
  blackScreenReminder:
    "Rappel : une fois la mise à jour terminée, l’écran restera noir pendant environ 15 secondes avant de se rallumer. Ne déconnectez pas vos lunettes pendant ce délai.",
  connectYourGlasses: "Connectez vos lunettes",
  connectUsbInstruction:
    "Connectez vos lunettes à un port USB-C de votre ordinateur, puis cliquez sur <strong>Connecter les lunettes</strong>.",
  selectDeviceInstruction:
    "Lorsque vous y êtes invité, sélectionnez vos lunettes dans la liste des appareils, puis cliquez sur <strong>Connecter</strong>.",
  windowsConnectionHelp:
    "Vous ne parvenez pas à connecter RayNeo Air Plus ou Air 1s sous Windows ?",
  connectGlasses: "Connecter les lunettes",
  networkException: "Erreur réseau. Vérifiez votre connexion et réessayez.",
  windowsRecognitionTitle: "RayNeo Air Plus et Air 1s ne sont pas reconnus",
  windowsStepOne:
    "1. Appuyez simultanément sur les touches Win + X. Dans le menu qui s’affiche, cliquez sur « Gestionnaire de périphériques » pour afficher la liste des périphériques.",
  windowsStepTwo:
    '2. Si « STM32 DownLoad Firmware Update » apparaît sous « Autres périphériques » dans la liste, sélectionnez « STM32 Download Firmware Update », cliquez sur <a href="https://zadig.akeo.ie/" target="_blank" rel="noopener noreferrer">zadig</a> pour installer le pilote, puis reconnectez les lunettes afin qu’elles soient reconnues.',
  gotIt: "Compris",
  damagedFirmware:
    "Le micrologiciel est endommagé. Veuillez le réparer sans attendre.",
  currentFirmwareVersion: "Version actuelle du micrologiciel : {version}",
  latestFirmwareVersion:
    "Vous utilisez déjà la dernière version du micrologiciel.",
  newFirmwareAvailable:
    "Une nouvelle version du micrologiciel ({version}) est disponible.",
  details: "Détails",
  newFirmwareInstructions:
    "Notes relatives à la nouvelle version du micrologiciel",
  noInstructions: "Aucune note n’est disponible pour le moment.",
  repairFirmware: "Réparer le micrologiciel",
  upgradeFirmware: "Mettre à jour le micrologiciel",
  popupInstruction:
    "Si une fenêtre contextuelle s’affiche pendant la mise à jour, sélectionnez votre appareil, puis cliquez sur « Connecter ».",
  fixingFirmware: "Réparation du micrologiciel…",
  upgradingFirmware: "Mise à jour du micrologiciel…",
  doNotCloseDuringUpdate:
    "Ne fermez ni n’actualisez cette page et ne déconnectez pas vos lunettes pendant la mise à jour.",
  firmwareRepairComplete: "Réparation du micrologiciel terminée",
  firmwareUpdateComplete: "Mise à jour du micrologiciel terminée",
  firmwareCompleteDescription:
    "Votre {model} utilise désormais la version {version} du micrologiciel.",
  rayneoGlasses: "lunettes RayNeo",
  firmwareRepairFailed: "Échec de la réparation du micrologiciel",
  firmwareOtaUpdateFailed: "Échec de la mise à jour OTA du micrologiciel",
  retryUpdate: "Réessayer la mise à jour",
  repeatedProblems:
    "Si le problème persiste, débranchez les lunettes, actualisez la page, puis réessayez.",
  deviceDisconnected:
    "L’appareil a été déconnecté. Vérifiez la connexion et réessayez.",
  networkError: "Erreur réseau. Vérifiez votre connexion et réessayez.",
  firmwareUpdateFailedReconnect:
    "La mise à jour du micrologiciel a échoué. Débranchez puis rebranchez vos lunettes et réessayez.",
  firmwareUpdateFailedSelect:
    "La mise à jour du micrologiciel a échoué. Sélectionnez votre appareil et réessayez.",
  firmwareDownloadAddressEmpty:
    "L’adresse de téléchargement du micrologiciel est vide. Mise à jour impossible.",
  firmwareUpdateRequestFailed:
    "Échec de la demande de mise à jour du micrologiciel. Vérifiez votre connexion et réessayez.",
  singleDeviceDuringUpdate:
    "Veillez à ce qu’une seule paire de lunettes RayNeo soit connectée à l’ordinateur pendant la mise à jour.",
  failedGetDeviceInformation:
    "Impossible d’obtenir les informations sur l’appareil ({error}). Actualisez la page et réessayez.",
  deviceConnectionError:
    "Erreur de connexion de l’appareil. Débranchez puis rebranchez vos lunettes et réessayez.",
  browserUnsupported:
    "Le navigateur actuel ne prend pas en charge la mise à jour du micrologiciel",
  openWithBrowsers: "Ouvrez cette page dans l’un des navigateurs suivants",
  browserVersionGreaterThan: "Version supérieure à {version}",
  mobileNotSupported:
    "La mise à jour du micrologiciel n’est pas encore prise en charge sur les appareils mobiles",
  useComputerBrowsers:
    "Pour mettre à jour le micrologiciel, utilisez l’un des navigateurs suivants sur votre ordinateur",
  dfuPackageMismatch:
    "Les fichiers .dfu du fichier ZIP ne correspondent pas aux interfaces DFU de l’appareil. Vérifiez le package du micrologiciel et l’appareil.",
  firmwareDownloadFailed:
    "Échec du téléchargement du fichier du micrologiciel.",
};
